import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";

import { onChange } from "./helpers/on-change"

const DEFAULT_BORDER_RADIUS_PATH: string = "properties.styles.common.borderRadius";
const DEFAULT_BORDER_RADIUS_PATH_V3: string = "properties.styles.$deviceType.borderRadius";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const BorderRadius = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];
  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_RADIUS_PATH_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.borderRadius) {
        const computedValue = parseInt(computedStyles.borderRadius, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (component) {
      const previousValue = getValue(component, DEFAULT_BORDER_RADIUS_PATH.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  return (
    <div className="panel-div">
      <label
        htmlFor="horizontal"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        disabled={!isCheckedIn}
        type="number"
        min="0"
        id="borderradius"
        value={value}
        className="panel-input"
        placeholder="Enter border radius"
        onChange={e => {
          const changeValue = e.target.value;
          const value = changeValue ? Number(changeValue) > 0 ? changeValue : "0": changeValue;
          setValue(value, () => onChange({
            path: isCoreV3 ? DEFAULT_BORDER_RADIUS_PATH_V3 : DEFAULT_BORDER_RADIUS_PATH,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
};